


























import Vue from "vue";
import activiteCard from "@/features/activites/components/activite-card.vue";

export default Vue.extend({
  props: {
    types: {
      default: [],
    },
    categorie: {
      default: "categorie",
    },
  },
  components: {
    activiteCard,
  },
  methods: {
    trim(str: string) {
      return str.replace(/\s/g, "_");
    },
  },
});
